import addDetailsToCustomerAddon from '@/views/profile/plans/addons/addDetailsToCustomerAddon'


const TRAVEL_ADDON_PRODUCT_TYPE = 'travelMobileAddon'
const TRAVEL_ADDON_PLAN_TYPE = 'TravelMobileAddon'


export function isTravelAddon(addon = {}) {
    return addon.ProductType === TRAVEL_ADDON_PRODUCT_TYPE
        || addon.PlanType === TRAVEL_ADDON_PLAN_TYPE
}


export function resolveAddonPriceCents(addon = {}) {
    if (Array.isArray(addon.Prices) && addon.Prices.length) {
        const price = addon.Prices[0] || {}
        return price.DiscountedPrice ?? price.RetailCents ?? price.OrigianlPrice ?? 0
    }

    return isTravelAddon(addon)
        ? (addon.PurchaseRetailPrice ?? 0)
        : (addon.RecurringRetailPrice ?? 0)
}


export default function mapTravelMobileAddon(addon) {
    const cents = resolveAddonPriceCents(addon)

    return addDetailsToCustomerAddon({
        ...addon,
        isCurrentPlan: true,
        isCurrentNextPlan: false,
        name: addon.Name,
        cost: (cents / 100).toFixed(2),
        more_details: addon.Description,
    })
}
